<template>
    <div>
      <div v-if="listType==='baseCourse'">
        <div class="t_header">{{courseItem.courseName}} {{courseItem.courseCode}} 
            ({{dictList.find(v=>v.value===courseItem.examinationType)?dictList.find(v=>v.value===courseItem.examinationType).label:''}}/
            {{videoTypeList.find(v=>v.id===Number(courseItem.videoType))?videoTypeList.find(v=>v.id===Number(courseItem.videoType)).videoTypeTitle:''}}/
            {{courseAttributeList.find(v=>v.id===courseItem.courseAttribute)?courseAttributeList.find(v=>v.id===courseItem.courseAttribute).label:''}})</div>
        <!-- <el-button @click="handleExport" type="primary" size="small" class="t_button">导出结果</el-button> -->
        <dibbleItemSelect @change="handleSearch" @export="handleExport"></dibbleItemSelect>
        <DibbleItemListTable :type="'baseCourse'" :tableData="tableData"></DibbleItemListTable>
        <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
      </div>
    </div>
</template>

<script>
import DibbleItemListTable from "./dibbleItemListTable.vue";
import dibbleItemSelect from './dibbleItemSelect.vue'
import pagination from "../ClassStatistics/Pagination/index.vue";
import {getVideoType} from '@/api/TeacherClassroomManagement/MyClassroomTution'
import {
    getAlbumTotalCount,
    getAlbumMajorList,
    getAlbumSchoolList,
    getAlbumMhmList,
    getBatchList
} from "@/api/TeachingStatistics";
export default {
    props:{
      courseItem: {type:Object,default:()=>{return {}}},
      listType: {type:String,default:''}
    },
    components: {
        DibbleItemListTable,
        pagination,
        dibbleItemSelect
    },
    data() {
        return {
          activeName: "baseCourse",
          tableData: [],
          totalCount: {},
          total: 0,
          queryParams:{pageSize:10,pageNum:1},
          tableName:'',
          isShow:true,
          videoTypeList: [], // 考试类别
          dictList:[
            {label: "笔试",value:'1'},
            {label: "实践考核",value:'2'}
          ], // 考试方式
          courseAttributeList:[
            {id:'1',label:'考核'},
            {id:'2',label:'培训'},
          ], // 课程属性
        };
    },
    computed: {
      url() {
        let url = window.location.protocol + "//" + window.location.host;
        if (window.location.host == "localhost:5001"  ) {
          url = "http://gz.hnjk.net";
        }
        return url;
      },
    },
    methods: {
        // 标签页切换
        async handleClick() {
            if (this.listType === "baseCourse") {
              const {data} = await getBatchList({...this.queryParams,courseId:this.courseItem.courseId});
              if(data.code === 100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
            if (this.listType === "school") {
              const res = await getAlbumSchoolList();
              this.tableData = res.data.data;
            }
            if (this.listType === "company") {
              const res = await getAlbumMhmList();
              this.tableData = res.data.data;
            }
        },
        /** 搜索/重置事件 */
        async handleSearch(params){
          if (this.listType === "baseCourse") {
            const {data} = await getBatchList({...this.queryParams,courseId:this.courseItem.courseId});
            if(data.code === 100000){
              this.tableData = data.data.list;
              this.total = data.data.total;
            }
          }
        },
        /** 导出结果事件 */
        handleExport(form){
           if(this.listType==='baseCourse'){
            window.open(
              `${this.url}/zkfz/statistics/batchListExport?courseId=${this.courseItem.courseId}&batch=${form.batch}&albumTitle=${form.albumTitle}&status=${form.status}&rkMhmName=${form.rkMhmName}&rkTeacherName=${form.rkTeacherName}`
            );
          }
        },
        /** 获取考试类别 */
        async getVideoTypes(){
          let {data} = await getVideoType()
          this.videoTypeList = data.data;
        },
    },
    mounted() {
        this.handleClick();
        this.getVideoTypes();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    background-color: #64b0ff;
    span {
        color: #fff;
        .num {
            font-size: 24px;
            font-weight: 700;
            color: red;
        }
        .num:hover {
            color: #409eff;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #d7d7d7;
    border: 0;
    span {
        color: #000;
        .num {
            color: red;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    height: 70px;
    padding-top: 30px;
    margin-top: 3px;
}
.t_header{
  background-color: #64b0ff;
  height: 58px;
  // margin: 0 auto;
  text-align: center;
  line-height: 58px;
  color: white;
  margin-top: 2px;
}
.t_button{
  margin: 20px 0px 0px 20px;
}
</style>